import { convertEntities } from '@amzn/awscat-editor';
import { ContentMetadata } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Link } from '@amzn/awsui-components-core';

interface Props {
  contentId: string;
  workflowId: number;
  metadata: ContentMetadata;
}

const FinalizingContentViewerLink: React.FunctionComponent<Props> = (props: Props) => {
  const { contentId, workflowId, metadata } = props;
  const appContext = useContext(AppContext);
  return (
    <Link
      variant="secondary"
      href={`/content-finalizing-viewer/tech-writer/${contentId}/${workflowId}`}
      target="_blank"
    >
      {convertEntities(metadata.contentName, appContext.entities)}
    </Link>
  );
};

export default FinalizingContentViewerLink;
